import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import AppEpiphany from "./AppEpiphany";
import reportWebVitals from "./reportWebVitals";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import Keycloak from "keycloak-js";
import { env } from "./env";
const keycloak = new Keycloak({
  url: env.REACT_APP_KEYCLOAK_INSTANCE,
  realm: env.REACT_APP_KEYCLOAK_REALM,
  clientId: env.REACT_APP_KEYCLOAK_CLIENDID,
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ReactKeycloakProvider
    authClient={keycloak}
    initOptions={{ onLoad: "login-required" }}
  >
    <React.StrictMode>
      <AppEpiphany />
    </React.StrictMode>
  </ReactKeycloakProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
